export default "__VITE_ASSET__78008231__"